import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {DatePipe} from '@angular/common';
import {EnquadradaDesenquadradaOutput} from './consultas/enquadrada-filtro/EnquadradaDesenquadradaOutput';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {handleError} from '../shared/util/error-util';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private readonly uiUrl = '/v1/dashboard';

  constructor(private readonly datePipe: DatePipe,
              private readonly httpClient: HttpClient) {
  }

  getQuantidadeTotalRegras(): Observable<any> {
    return this.httpClient.get<any>(`${this.uiUrl}/regras/total`).pipe(catchError(handleError));
  }

  getQuantidadeTotalCarteiras(): Observable<any> {
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras/total`).pipe(catchError(handleError));
  }

  findCarteirasByStatus(value: EnquadradaDesenquadradaOutput) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params: HttpParams = new HttpParams();
    Object.keys(value).forEach(item => {
      if (this.notNullNotEmpty(value[item])) params = params.set(item, value[item])
    });

    if (value.dataUltimoProcessamento) {
      params = params.set('dataUltimoProcessamento', this.datePipe.transform(value.dataUltimoProcessamento, 'yyyy-MM-dd'));
    }

    params = params.set("size", "10");
    params = params.set("page", value.page);
    const options = {headers, params};
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras`, options);
  }

  findCarteirasByStatusProcessadas(value: EnquadradaDesenquadradaOutput) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params: HttpParams = new HttpParams();
    Object.keys(value).forEach(item => {
      if (this.notNullNotEmpty(value[item])) params = params.set(item, value[item])
    });

    if (value.dataUltimoProcessamento) {
      params = params.set('dataUltimoProcessamento', this.datePipe.transform(value.dataUltimoProcessamento, 'yyyy-MM-dd'));
    }

    params = params.set("size", "10");
    params = params.set("page", value.page);
    const options = {headers, params};
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras-processadas`, options);
  }

  findCarteirasByStatusNaoProcessadas(value: EnquadradaDesenquadradaOutput) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params: HttpParams = new HttpParams();
    Object.keys(value).forEach(item => {
      if (this.notNullNotEmpty(value[item])) params = params.set(item, value[item])
    });

    if (value.dataUltimoProcessamento) {
      params = params.set('dataUltimoProcessamento', this.datePipe.transform(value.dataUltimoProcessamento, 'yyyy-MM-dd'));
    }

    params = params.set("size", "10");
    params = params.set("page", value.page);
    const options = {headers, params};
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras-nao-processadas`, options);
  }

  findCarteirasByComRegras(value: EnquadradaDesenquadradaOutput) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params: HttpParams = new HttpParams();
    Object.keys(value).forEach(item => {
      if (this.notNullNotEmpty(value[item])) params = params.set(item, value[item])
    });

    params = params.set("size", "10");
    params = params.set("page", value.page);
    const options = {headers, params};
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras-com-regras`, options);
  }

  findCarteirasBySemRegras(value: EnquadradaDesenquadradaOutput) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params: HttpParams = new HttpParams();
    Object.keys(value).forEach(item => {
      if (this.notNullNotEmpty(value[item])) params = params.set(item, value[item])
    });

    params = params.set("size", "10");
    params = params.set("page", value.page);
    const options = {headers, params};
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras-sem-regras`, options);
  }

  findCarteirasByStatusCanceladas(value: EnquadradaDesenquadradaOutput) {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    let params: HttpParams = new HttpParams();
    Object.keys(value).forEach(item => {
      if (this.notNullNotEmpty(value[item])) params = params.set(item, value[item])
    });

    if (value.dataUltimoProcessamento) {
      params = params.set('dataUltimoProcessamento', this.datePipe.transform(value.dataUltimoProcessamento, 'yyyy-MM-dd'));
    }

    params = params.set("statusProcessamento", "CANCELADO");

    params = params.set("size", "10");
    params = params.set("page", value.page);
    const options = {headers, params};
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras`, options);
  }

  getQuantidadeCarteiraEnquadrada() {
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras/enquadradas/total`).pipe(catchError(handleError));
  }

  getQuantidadeCarteiraDesenquadrada() {
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras/desenquadradas/total`).pipe(catchError(handleError));
  }

  getUltimaDataProcessamento() {
    return this.httpClient.get<any>(`${this.uiUrl}/processamento/ultima-data`).pipe(catchError(handleError));
  }

  getQuantidadeCarteiraProcessada() {
    return this.httpClient.get<any>(`${this.uiUrl}/processamento/carteiras/processadas/total`).pipe(catchError(handleError));
  }

  getQuantidadeCarteiraNaoProcessada() {
    return this.httpClient.get<any>(`${this.uiUrl}/processamento/carteiras/nao-processadas/total`).pipe(catchError(handleError));
  }

  getQuantidadeCarteiraAssociadas() {
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras/associadas/total`).pipe(catchError(handleError));
  }

  getQuantidadeCarteiraNaoAssociadas() {
    return this.httpClient.get<any>(`${this.uiUrl}/carteiras/nao-associadas/total`).pipe(catchError(handleError));
  }

  getQuantidadeRegraEnquadrada() {
    return this.httpClient.get<any>(`${this.uiUrl}/regras/enquadradas/total`).pipe(catchError(handleError));
  }

  getQuantidadeRegraDesenquadrada() {
    return this.httpClient.get<any>(`${this.uiUrl}/regras/desenquadradas/total`).pipe(catchError(handleError));
  }

  getQuantidadeCarteiraCancelada() {
    return this.httpClient.get<any>(`${this.uiUrl}/processamento/carteiras/canceladas/total`).pipe(catchError(handleError));
  }

  private notNullNotEmpty(value) {
    return value !== null && value !== "" && value !== undefined;
  }
}
